import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useEffect } from 'react';
import { usePersistState } from '../usePersistState';
export const DEVTOOLS_LOCALSTORAGE_KEY = '@tmapy/devtools';
// mix up and down events - hold alt, then 3x shift
// sequence is read from end
export const defaultMagicSequence = [
    'ShiftLeft',
    'ShiftLeft',
    'ShiftLeft',
    'ShiftLeft',
    'ControlLeft',
    'ControlLeft',
    'ShiftLeft',
    'ShiftLeft',
    'ShiftLeft',
    'ShiftLeft',
    'ControlLeft',
    'ControlLeft',
    'ShiftLeft',
    'ShiftLeft',
    'ShiftLeft',
    'ShiftLeft',
    'ControlLeft',
    'ControlLeft',
];
const defaultPosition = { left: 0, top: 0 };
const defaultOptions = {
    active: false,
    position: defaultPosition,
};
export const DevToolsContainer = ({ magicSequence = defaultMagicSequence, }) => {
    const [options, setOptions] = usePersistState(DEVTOOLS_LOCALSTORAGE_KEY, defaultOptions);
    const { active } = options;
    const [devToolsModule, setDevToolsModule] = useState(null);
    useEffect(() => {
        if (active && !devToolsModule) {
            // eslint-disable-next-line node/no-unsupported-features/es-syntax
            import(/* webpackChunkName: "tmapy-devtools" */ './DevTools').then((module) => setDevToolsModule(module));
        }
        let remaining = [...magicSequence];
        function windowKeyEventHandler(e) {
            const expected = remaining.pop();
            if (e.code !== expected) {
                remaining = [...magicSequence];
                return;
            }
            if (remaining.length === 0) {
                setOptions({ ...defaultOptions, active: true });
                remaining = [...magicSequence];
            }
        }
        window.addEventListener('keydown', windowKeyEventHandler);
        window.addEventListener('keyup', windowKeyEventHandler);
        return () => {
            window.removeEventListener('keydown', windowKeyEventHandler);
            window.removeEventListener('keyup', windowKeyEventHandler);
        };
    }, [active, devToolsModule, magicSequence, setOptions]);
    if (!active)
        return null;
    if (!devToolsModule)
        return null;
    const { DevTools } = devToolsModule;
    return _jsx(DevTools, { options: options, setOptions: setOptions });
};
//# sourceMappingURL=DevToolsContainer.js.map